export const getRouterData = ({ router }) => router;
